import React from "react";

export default function CSMobileHeader({ headerTxt }) {
    return (
        <>
            <div className="lg:hidden sticky top-0 left-0 w-full h-[70px] bg-white shadow-md flex items-center px-2 z-50">
                <p className=" text-coalBlack headingText capitalize px-2">
                    {headerTxt}
                </p>
            </div>

        </>
    )
}